import { action, observable, toJS, computed } from 'mobx';

const STORE_AUTH = 'auth';

class AuthStore {
  constructor(rawState = {}) {
    if(rawState.user) {
      this.setUser(rawState.user);
    }
    if(rawState.email) {
      this.setEmail(rawState.email);
    }
    if(rawState.pin) {
      this.setPin(rawState.pin);
    }
  }
  toJS() {
    return {
      user: toJS(this.user),
      email: toJS(this.email),
      pin: toJS(this.pin),
    };
  }

  @observable user;
  @action setUser(value) {
    this.user = value;
  }

  @observable email = '';
  @action setEmail(value) {
    this.email = value;
  }

  @observable pin = '';
  @action setPin(value) {
    this.pin = value;
  }

  @computed get token() {
    return this.user && this.user.Token ? this.user.Token : null;
  }
}

export { AuthStore, STORE_AUTH };